"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeBaskets = exports.getOffers = exports.getHotelsIDs = exports.findSimplifyBasketIndex = exports.basketsSimplifiedNormalizer = exports.basketNormalizer = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _helpers = require("@otpusk/apisearch-toolbox/dist/offers/helpers");
var _excluded = ["offers", "short_url", "views_count", "full_url", "send_count", "show_price_with_margin", "emails", "margin", "discount", "id", "comment", "round"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var basketNormalizer = exports.basketNormalizer = function basketNormalizer(_ref) {
  var offers = _ref.offers,
    shortUrl = _ref.short_url,
    viewCount = _ref.views_count,
    fullUrl = _ref.full_url,
    sendCount = _ref.send_count,
    showPriceWithMargin = _ref.show_price_with_margin,
    emails = _ref.emails,
    margin = _ref.margin,
    discount = _ref.discount,
    basketID = _ref.id,
    comment = _ref.comment,
    round = _ref.round,
    rest = _objectWithoutProperties(_ref, _excluded);
  return R.mergeAll([rest, {
    offersIDs: R.map(function (_ref2) {
      var offer = _ref2.offer;
      return (0, _helpers.generateOfferKey)(offer.id, {
        basketID: basketID
      });
    }, offers),
    offersExtra: R.call(R.pipe(R.map(function (_ref3) {
      var id = _ref3.id,
        offer = _ref3.offer,
        offerComment = _ref3.comment,
        editedPrice = _ref3.editedPrice;
      return [(0, _helpers.generateOfferKey)(offer.id, {
        basketID: basketID
      }), {
        id: id,
        comment: offerComment,
        editedPrice: editedPrice
      }];
    }), R.fromPairs), offers),
    shortUrl: shortUrl,
    showPriceWithMargin: Boolean(showPriceWithMargin),
    fullUrl: fullUrl,
    id: basketID,
    sendCount: R.or(sendCount, 0),
    viewCount: R.or(viewCount, 0),
    margin: R.or(margin, undefined),
    discount: R.or(discount, undefined),
    emails: R.or(emails, []),
    comment: R.or(comment, ''),
    round: Boolean(round)
  }]);
};
var basketsSimplifiedNormalizer = exports.basketsSimplifiedNormalizer = R.over(R.lensProp('offers'), R.map(R.applySpec({
  id: R.prop('offerid'),
  extra: {
    id: R.prop('id')
  }
})));
var getOffers = exports.getOffers = function getOffers(baskets) {
  return R.call(R.pipe(R.map(function (_ref4) {
    var offers = _ref4.offers,
      basketID = _ref4.id;
    return R.map(function (_ref5) {
      var offer = _ref5.offer;
      return R.mergeAll([offer, {
        id: (0, _helpers.generateOfferKey)(offer.id, {
          basketID: basketID
        })
      }]);
    }, offers);
  }), R.flatten), baskets);
};
var getHotelsIDs = exports.getHotelsIDs = function getHotelsIDs(baskets) {
  return R.call(R.pipe(R.map(R.prop('offers')), R.flatten, R.map(R.path(['offer', 'hotelId']))), baskets);
};
var mergeBaskets = exports.mergeBaskets = function mergeBaskets(prevBaskets, newBaskets) {
  return R.uniqBy(R.prop('id'), R.concat(prevBaskets, newBaskets));
};
var findSimplifyBasketIndex = exports.findSimplifyBasketIndex = function findSimplifyBasketIndex(state, basketID) {
  return R.findIndex(R.propEq(basketID, 'id'), R.prop('basketsSimplified', state));
};